import { render, staticRenderFns } from "./AdminSuperMemberMilestones.vue?vue&type=template&id=bb472b4a&scoped=true&lang=pug&"
import script from "./AdminSuperMemberMilestones.vue?vue&type=script&lang=js&"
export * from "./AdminSuperMemberMilestones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb472b4a",
  null
  
)

export default component.exports